import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Modal, Header, Button } from "semantic-ui-react";
import TourStore from "~/stores/TourStore";
import ErrorWrapper from "~/components/wrapper/ErrorWrapper";

@observer
class TourIsActiveToggleButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalShow: false,
    };
  }

  activateTour = () => {
    const { tourStore, showError } = this.props;
    tourStore.saveTour(tourStore.tour.tourId, { isActive: true }).catch(e => {
      showError(e);
    });
  };

  deactivateTour = () => {
    const { /** @var {TourStore} */ tourStore } = this.props;
    tourStore.deactivateTour();
    this.handleClose();
  };

  handleOpen = () => this.setState({ modalShow: true });

  handleClose = () => this.setState({ modalShow: false });

  render() {
    const { /** @var {TourStore} */ tourStore, t, customerHasUrbanimmersiveGroupSpecialPricing } = this.props;
    const { modalShow } = this.state;

    if (!customerHasUrbanimmersiveGroupSpecialPricing && !tourStore.tour.isActive) {
      return null;
    }

    if (!tourStore.tour.isActive) {
      return (
        <span className="tour-header-deactivate-span" onClick={this.activateTour}>
          {t("clientPanelMisc:activateTour")}
        </span>
      );
    }

    return (
      <Modal
        open={modalShow}
        trigger={
          <span className="tour-header-deactivate-span" onClick={this.handleOpen}>
            {t("clientPanelMisc:deactivateTour")}
          </span>
        }
      >
        <Header icon="remove" content={t("clientPanelMisc:deactivateTour")} />
        <Modal.Content>
          <p>{t("clientPanelMisc:areYouSureDeactivateTour")}</p>
          {!customerHasUrbanimmersiveGroupSpecialPricing && (
            <p>{t("clientPanelMisc:noteOnlyPhotographerReactivateTour")}</p>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button color="green" inverted onClick={this.handleClose}>
            {t("no")}
          </Button>
          <Button color="red" inverted onClick={this.deactivateTour}>
            {t("yes")}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}
TourIsActiveToggleButton.propTypes = {
  tourStore: PropTypes.instanceOf(TourStore),
  t: PropTypes.func.isRequired,
  customerHasUrbanimmersiveGroupSpecialPricing: PropTypes.bool.isRequired,
};

export default withTranslation()(ErrorWrapper(TourIsActiveToggleButton));
